import { createSlice } from '@reduxjs/toolkit';
import type { RootState } from '../../app/rootReducer';

interface SideBarRight {
  visible: boolean;
}

const initialState: SideBarRight = {
  visible: false,
};

export const sideBarRightSlice = createSlice({
  name: 'sidebar',
  initialState,
  reducers: {
    showSideBarRight(state) {
      state.visible = true;
    },
    hideSideBarRight(state) {
      state.visible = false;
    },
  },
});

export const { showSideBarRight, hideSideBarRight } = sideBarRightSlice.actions;

export const selectSideBarRightState = (state: RootState) =>
  state.sideBarRightReducer;

export default sideBarRightSlice.reducer;
